/* eslint-disable no-unused-vars */
import React, { useCallback } from 'react'
import propTypes from 'prop-types'
import { AdminPageWrapper, PageHeader, ProjectBrokerLeads } from 'components'
import { TFilledPlusIcon } from 'components/Icons'
import { useHistory } from 'react-router-dom'
import { ADMIN_BROKER_LEADS_NEW } from 'routes'
import { connect } from 'react-redux'

import { isMobile } from 'react-device-detect'

const Button = (props) => {
  return (
    <button
      className='flex justify-center items-center font-bold p-3 bg-volt rounded cursor-pointer w-48'
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  )
}

const BrokerLeads = (props) => {
  const { appProject } = props
  const history = useHistory()

  const createBrokerLead = useCallback(() => {
    history.push({
      pathname: ADMIN_BROKER_LEADS_NEW,
      state: {
        projectId: appProject
      }
    })
  }, [appProject, history])

  const RightContent = () => (
    <div className='flex flex-row items-center'>
      <Button disabled={!appProject} onClick={() => createBrokerLead()}>
        <TFilledPlusIcon className='h-6 w-3' />
        {isMobile ? 'Create' : 'Create Page'}
      </Button>
    </div>
  )

  return (
    <>
      <PageHeader title='Broker Landing Pages' rightContent={<RightContent />} />
      <AdminPageWrapper style={{ height: 'calc(100vh - 100px)' }} fullscreen>
        <ProjectBrokerLeads />
      </AdminPageWrapper>
    </>
  )
}

const mapStateToProps = (state) => ({
  appProject: state.appReducer.appProject
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(BrokerLeads)

BrokerLeads.propTypes = {
  appProject: propTypes.string
}

Button.propTypes = {
  disabled: propTypes.bool,
  onClick: propTypes.func,
  children: propTypes.node
}
